import React from 'react';
import {
  Grid,
  TextField
} from '@mui/material';
import { formatValue } from './JobFormHelpers';

export const AdvancedSettingsSection = ({ 
  formik, 
  loading, 
  hasError, 
  getErrorMessage 
}) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TextField
          fullWidth
          id="settings"
          name="settings"
          label="Additional Settings (JSON)"
          variant="outlined"
          multiline
          rows={4}
          value={formatValue(formik.values.settings, 'json')}
          onChange={(e) => {
            try {
              // Attempt to parse as JSON
              const parsedJson = JSON.parse(e.target.value);
              formik.setFieldValue('settings', parsedJson);
            } catch (err) {
              // If not valid JSON, store as string
              formik.setFieldValue('settings', e.target.value);
            }
          }}
          onBlur={formik.handleBlur}
          error={hasError(formik, 'settings')}
          helperText={
            hasError(formik, 'settings')
              ? getErrorMessage(formik, 'settings')
              : "Optional JSON configuration specific to this job"
          }
          disabled={loading}
        />
      </Grid>
    </Grid>
  );
};